<template>
  <div class="row no-gutters body">
    <!-- <div class="col-12">
      <div class="row no-gutters header">
        <div class="col d-flex">
          <div class="col-lg-3 col-md-2 col-sm-1 d-flex">
            <sidemenu></sidemenu>
          </div>
          <div class="col-lg-9 col-11 col-sm-12 topmenubar">
            <topmenu></topmenu>
          </div>
        </div>
      </div>
    </div> -->

    <div class="col-12 ">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background pb-5 main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-5">
            <div class="col-lg-11">
              <div class="row no-gutters">
                <br />
              </div>
              <div class="fontsize20 black proximanova privacyHeading pl-3 my-auto pointer" @click="previous"><img src="../assets/Back.svg" class="img-fluid mr-1 my-auto pointer" alt="back" /> Privacy and Settings</div>
              <div class="proximanova-semibold fontsize12 black60 pl-5 mt-lg-3 mt-3 mb-4">PRIVACY</div>
              <div class="card card1 ml-3 mr-3 mt-lg-2">
                <div class="card-body">
                    <div class="col-12 cardpadding">
                        <div class="d-flex flex-column">
                            <span class="proximanova-semibold black60 fontsize16 ">Profile Visibility</span>
                            <span class="proximanova black80 fontsize14 mt-2">Keeping your profile Visible is a trap. Make sure to whome you need to visible.</span>
                            <div class="pt-4 pb-3">
                                <div class="d-flex">
                                    <input type="radio" id="onlyMe1" name="privacy1" value="PRIVATE" class="my-auto" v-model="ProfileVisibility" @change="updatevisibility()">
                                    <label for="onlyMe1" class="proximanova black80 fontsize14 ml-2 my-auto">Only to me</label><br>
                                </div>
                                <div class="d-flex">
                                    <input type="radio" id="onlyMyfollower1" name="privacy1" value="FOLLOWER" class="my-auto" v-model="ProfileVisibility" @change="updatevisibility()">
                                    <label for="onlyMyfollower1" class="proximanova black80 fontsize14 ml-2 my-auto">Only to my follower</label><br>
                                </div>
                                <div class="d-flex">
                                    <input type="radio" id="Public1" name="privacy1" value="PUBLIC" class="my-auto" v-model="ProfileVisibility" @change="updatevisibility()">
                                    <label for="Public1" class="proximanova black80 fontsize14 ml-2 my-auto">Public</label><br>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <div class="contentdevider pt-4"></div>
                    <div class="col-12 cardpadding">
                        <div class="d-flex flex-column">
                            <span class="proximanova black60 fontsize16 subhead1">Show Profile Video</span>
                            <span class="proximanova black80 fontsize14 mt-2">Who can see your profile video?</span>
                            <div class="pt-4 pb-3">
                                <div class="d-flex">
                                    <input type="radio" id="onlyMe2" name="privacy2" value="PRIVATE" class="my-auto" :disabled="videoonlyenabled" v-model="ProfileVideoVisibility" @change="profileVideoVisibility()">
                                    <label for="onlyMe2" class="proximanova black80 fontsize14 ml-2 my-auto">Only to me</label><br>
                                </div>
                                <div class="d-flex">
                                    <input type="radio" id="onlyMyfollower2" name="privacy2" value="FOLLOWER" class="my-auto" :disabled="videofollwersenabled" v-model="ProfileVideoVisibility" @change="profileVideoVisibility()">
                                    <label for="onlyMyfollower2" class="proximanova black80 fontsize14 ml-2 my-auto">Only to my follower</label><br>
                                </div>
                                <div class="d-flex">
                                    <input type="radio" id="Public2" name="privacy2" value="PUBLIC" class="my-auto" :disabled="videopublicenabled" v-model="ProfileVideoVisibility" @change="profileVideoVisibility()">
                                    <label for="Public2" class="proximanova black80 fontsize14 ml-2 my-auto">Public</label><br>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="contentdevider pt-4"></div>
                    <div class="col-12 cardpadding">
                        <div class="d-flex flex-column">
                            <span class="proximanova black60 fontsize16 subhead1">Show Profile Picture</span>
                            <span class="proximanova black80 fontsize14 mt-2">Who can see your profile picture?</span>
                            <div class="pt-4 pb-3">
                                <div class="d-flex">
                                    <input type="radio" id="onlyMe3" name="privacy3" value="PRIVATE" class="my-auto" :disabled="pictureonlymeenabled" v-model="ProfilePictureVisibility" @change="profilePictureVisibility()">
                                    <label for="onlyMe3" class="proximanova black80 fontsize14 ml-2 my-auto">Only to me</label><br>
                                </div>
                                <div class="d-flex">
                                    <input type="radio" id="onlyMyfollower3" name="privacy3" value="FOLLOWER" class="my-auto" :disabled="picturefollwersenabled" v-model="ProfilePictureVisibility" @change="profilePictureVisibility()">
                                    <label for="onlyMyfollower3" class="proximanova black80 fontsize14 ml-2 my-auto">Only to my follower</label><br>
                                </div>
                                <div class="d-flex">
                                    <input type="radio" id="Public3" name="privacy3" value="PUBLIC" class="my-auto" :disabled="picturepublicenabled" v-model="ProfilePictureVisibility" @change="profilePictureVisibility()">
                                    <label for="Public3" class="proximanova black80 fontsize14 ml-2 my-auto">Public</label><br>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <!-- <div class="contentdevider pt-4"></div>
                    <div class="col-12 cardpadding">
                        <div class="d-flex flex-column">
                            <span class="proximanova black60 fontsize16 subhead1">Accepted follow Requests</span>
                            <div class="pt-4 pb-3 d-flex justify-content-start">
                                <div class="fontsize14 sidemenuItem proximanova" @click="acceptedRequests = !acceptedRequests">On</div>
                                <span class="custom-control custom-switch ml-2 sidemenuItem proximanova" @click="acceptedRequests = !acceptedRequests">
                                    <input
                                    type="checkbox"
                                    v-model="acceptedRequests"
                                    class="custom-control-input"
                                    id="switch1"
                                    name="example"
                                    />
                                    <label class="custom-control-label" for="switch1"></label>
                                </span>
                            </div>
                            <div class="horizontalLine"> </div>
                            <div class="mt-2">
                                <div class="float-right">
                                    <button class="mr-3 btn  button-cancel1 mouseoverbtn1 borderradius20">
                                        <span class="proximanova">Cancel</span>
                                    </button>
                                    <button class="mr-3 btn backgroundcolorblack mouseoverbtn2 white borderradius20" @click="acceptFollowRequest">
                                        <span class=" proximanova">Save</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
              </div>
              <div class="header-font-size pl-5 mt-lg-3 mt-3 mb-4">SETTINGS</div>
              <div class="card card1 ml-3 mr-3 mt-lg-2">
                <div class="card-body">
                    <div class="col-12 cardpadding">
                        <div class="d-flex flex-column">
                            <span class="proximanova black60 fontsize16 subhead1">Update Password</span>
                            <span class="proximanova black80 fontsize14 mt-2">Choosing a hard-to-guess, but easy-to-remember password is important! ...</span>
                          <center>  <span class="proximanova black80 fontsize14 mt-2" >{{message}}</span></center>
                            <div class="pt-4 pb-3">
                              <div class="form">
                                <div class="row mt-2">
                                  <div class="input-group col-lg-6 col-md-6 col-12">
                                    <input
                                      :type="oldtype"
                                      name="old password"
                                      class="input"
                                      v-validate="'required'"
                                      v-model="oldpassword"
                                      data-vv-as="old password"
                                      required
                                    />
                                    <div class="mt-2 ">
                                      <span>
                                        <img
                                          v-if="showoldpassword"
                                          @click="toggleoldimage"
                                          alt="show"
                                          id="viewpassword"
                                          src="../assets/ViewPassword_Dissabled.svg"
                                        />
                                        <img
                                          v-if="!showoldpassword"
                                          @click="toggleoldimage"
                                          alt="hide"
                                          id="viewpassword"
                                          src="../assets/ViewPassword.svg"
                                        />
                                      </span>
                                    </div>
                                    <span></span>
                                    <label class="label1">Old Password</label>

                                    <div
                                      v-if="errors.has('old password')"
                                      class="alert-danger ml-2"
                                    >{{ errors.first("old password") }}</div>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                  <div class="input-group col-lg-6 col-md-6 col-12">
                                    <input
                                      :type="newtype"
                                      name="new password"
                                      class="input"
                                      v-validate="'required'"
                                      v-model="newPassword"
                                      data-vv-as="new password"
                                      required
                                    />
                                    <div class="mt-2 ">
                                      <span>
                                        <img
                                          v-if="shownewpassword"
                                          @click="togglenewimage"
                                          alt="show"
                                          id="viewpassword"
                                          src="../assets/ViewPassword_Dissabled.svg"
                                        />
                                        <img
                                          v-if="!shownewpassword"
                                          @click="togglenewimage"
                                          alt="hide"
                                          id="viewpassword"
                                          src="../assets/ViewPassword.svg"
                                        />
                                      </span>
                                    </div>
                                    <span></span>
                                    <label class="label1">New Password</label>

                                    <div
                                      v-if="errors.has('new password')"
                                      class="alert-danger ml-2"
                                    >{{ errors.first("new password") }}</div>
                                  </div>
                                  <div class="input-group mt-3 mt-lg-0 col-lg-6 col-md-6 col-12">
                                    <input
                                      :type="confirmtype"
                                      name="confirm password"
                                      class="input"
                                      v-validate="'required'"
                                      v-model="confirmPassword"
                                      data-vv-as="confirm password"
                                      required
                                    />
                                    <div class="mt-2 ">
                                      <span>
                                        <img
                                          v-if="showconfirmpassword"
                                          @click="toggleconfirmimage"
                                          alt="show"
                                          id="viewpassword"
                                          src="../assets/ViewPassword_Dissabled.svg"
                                        />
                                        <img
                                          v-if="!showconfirmpassword"
                                          @click="toggleconfirmimage"
                                          alt="hide"
                                          id="viewpassword"
                                          src="../assets/ViewPassword.svg"
                                        />
                                      </span>
                                    </div>
                                    <span></span>
                                    <label class="label1">Confirm Password</label>

                                    <div
                                      v-if="errors.has('confirm password')"
                                      class="alert-danger ml-2"
                                    >{{ errors.first("confirm password") }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="horizontalLine"> </div>
                            <div class="mt-2">
                                <div class="float-right">
                                    <button class="mr-3 btn button-cancel1 mouseoverbtn1 borderradius20" @click="cancelUpdatedPassword">
                                        <span class="">Cancel</span>
                                    </button>
                                    <button class="mr-3 btn backgroundcolorblack white mouseoverbtn2 borderradius20" @click="changepassword">
                                        <span class="proximanova">Save</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <!-- <div class="card card1 ml-3 mr-3 mt-3">
                <div class="card-body">
                    <div class="col-12 cardpadding">
                        <div class="d-flex flex-column ">
                            <span class="re-send-otp text-left proximanova closebtn" @click="CloseAccount">Close Account</span>
                        </div>
                    </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <!-- <img src="../assets/uploadvideoloading.svg" alt=""> -->
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row row no-gutters">
            <br />
          </div>
          <pendingActivities />
        </div>
      </div>
    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    <!-- <Footer class="footer d-block d-sm-block d-md-block d-lg-none" /> -->
  </div>
</template>
<script>
import menus from "@/components/Menu.vue";
import sidemenu from "@/components/SideMenu.vue";
import pendingActivities from "../components/PendingActivities.vue";
import topmenu from "@/components/TopHeader.vue";
import Vue from "vue";
import Popover from "vue-js-popover";
import Footer from "../components/Footer";
import APIerrorModal from '../components/APIerrorpopup.vue'
import httpuserprofile from "@/js/http-userprofile.js";
import httpuserdetails from "@/js/http-userdetails.js";
import router from '../router'
import sessionUtils from '@/js/session-util.js'
Vue.use(Popover);

export default {
  components: {
    menus,
    sidemenu,
    topmenu,
    Footer,
    pendingActivities,
    APIerrorModal
  },

  data() {
    return {
      message:'',
      userdatalist:[],    
      userId:sessionUtils.getUserId(),
      profileId : '',
      profileVideoId : null,
      ProfileVisibility : 'PUBLIC',
      ProfileVideoVisibility : 'PUBLIC',
      ProfilePictureVisibility : 'PUBLIC',
      acceptedRequests : false,
      oldpassword : "",
      newPassword : null,
      confirmPassword : null,
      showoldpassword : true,
      shownewpassword : true,
      showconfirmpassword : true,
      oldtype : 'text',
      newtype : 'text',
      confirmtype : 'text',
      updatepasswordResponse :[],
      pictureonlymeenabled:false,
      picturepublicenabled:false,
      picturefollwersenabled:false,
      videoonlyenabled:false,
      videofollwersenabled:false,
      videopublicenabled:false,
      displayAPIerrorModal : false,
    };
  },
  methods: {
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
//this will invoke after change the visibility
// update the visibility of other features based on visibility of profile
updatevisibility: function(){
this.profileVisibility()
 if(this.profileVideoId === null){   
   this.ProfileVideoVisibility = ''
 }
if(this.ProfileVisibility === 'PRIVATE')
{
  this.ProfilePictureVisibility ='PRIVATE'
   this.picturepublicenabled = true
  this.picturefollwersenabled = true
   if(this.profileVideoId !== null)
{  
   this.ProfileVideoVisibility = 'PRIVATE'
   this.videofollwersenabled = true
   this.videopublicenabled=true
}
 
}
if(this.ProfileVisibility === 'FOLLOWER')
{
 this.ProfilePictureVisibility ='FOLLOWER'
  this.picturepublicenabled = true
  this.picturefollwersenabled = false
   this.pictureonlymeenabled=false
   if(this.profileVideoId !== null)
{  
  this.ProfileVideoVisibility = 'FOLLOWER'
  this.videoonlyenabled=false
   this.videofollwersenabled = false
   this.videopublicenabled=true
}

}
if(this.ProfileVisibility === 'PUBLIC')
{
  this.ProfilePictureVisibility ='PUBLIC' 
  this.picturepublicenabled = false
  this.picturefollwersenabled = false
   this.pictureonlymeenabled=false
    if(this.profileVideoId !== null)
{  
  this.ProfileVideoVisibility = 'PUBLIC'
  this.videoonlyenabled=false
   this.videofollwersenabled = false
   this.videopublicenabled=false
}
 
}

},
// this will invoke after click on save button to update password
 changepassword : function() {
   
    this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
           this.message='';
let newpassword={                  
           userId: this.userId,                                                                  
           otp:  this.userdatalist.otp,
           passwordSalt: this.newPassword,
           oldPassword:this.oldpassword
}

     if(this.newPassword === this.confirmPassword){
      httpuserdetails.put('/updatePassword',newpassword)
      .then((response) => {
        console.log(response)
        this.updatepasswordResponse = response.data;
        this.message = this.updatepasswordResponse.errorMessage;
        console.log(this.message);
    })} 
     else{
        this.message="NewPassword And Confirm Password Should Be Same";
      }
    
    } }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
     
    },
    // this will invoke after click on close account button
CloseAccount : function() {
      console.log("Navigate to another page")
      console.log(router)
      router.push({
        name : 'close'
      })
    },
    // fetching the user data
getUserDetailsDataById : function() {
     
      httpuserdetails.get('/getuserdataById', {
					params: {
					userId:sessionUtils.getUserId()
					}
				})
      .then((response) => {
       this.userdatalist = response.data
      }).catch((e) => {
        console.log(e)
      })
    },

    // this will invoke after updating the profile visibility
    // updating the other seactions visibility based on profile visibility
    profileVisibility() {
      console.log("profile visibility : ", this.ProfileVisibility)
      console.log("profileId : ", this.profileId)
      httpuserprofile.put('/userprofile/updateProfileVisibility?profileId='+this.profileId+'&visibility='+this.ProfileVisibility)
      .then((response) => {
        console.log(response)
       this.profileVideoVisibility();
       this.profilePictureVisibility();
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // updating the profile video visibility
    profileVideoVisibility() {
      console.log("profile video visibility : ", this.ProfileVideoVisibility)
      console.log("profile video Id : ", this.profileVideoId)
      if(this.profileVideoId !== null){
      // httpuserprofile.put('/userprofile/updateProfileVideoVisibility?videoId='+this.profileVideoId+'&visibility='+this.ProfileVideoVisibility)
      httpuserprofile.put('/userprofile/updateVideoVisibility?videoId='+this.profileVideoId+'&visibility='+this.ProfileVideoVisibility)
      .then((response) => {
        console.log(response)
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    }},
    // updating profile picture visibility
    profilePictureVisibility() {
      console.log("profile picture visibility : ", this.ProfilePictureVisibility)
      if(this.profileId !== null){
      httpuserprofile.put('/userprofile/updateProfilePictureVisibility?profileId='+this.profileId+'&visibility='+this.ProfilePictureVisibility)
      .then((response) => {
        console.log(response)
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    }},
    acceptFollowRequest : function(){
      console.log("accept follow requests : ", this.acceptedRequests)
    },
    // this will invoke after click on password image to show/hide password
    toggleoldimage() {
      if (this.showoldpassword == true) {
        this.oldtype = "text";
        this.showoldpassword = false;
      } else {
        this.oldtype = "password";
        this.showoldpassword = true;
      } 
    },
    // this will invoke after click on password image to show/hide password
    togglenewimage : function() {
      if(this.shownewpassword == true){
        this.newtype = "text";
        this.shownewpassword = false;
      } else {
        this.newtype = "password";
        this.shownewpassword = true;
      }
    },
    // this will invoke after click on password image to show/hide password
    toggleconfirmimage : function() {
      if(this.showconfirmpassword == true){
        this.confirmtype = "text";
        this.showconfirmpassword = false;
      } else {
        this.confirmtype = "password";
        this.showconfirmpassword = true;
      }
    },
    // this will invoke after click on cancel button update password section
    // clear password fields
    cancelUpdatedPassword : function() {
      this.oldpassword = null,
      this.newPassword = null,
      this.confirmPassword = null
    },
    UpdatedPassword : function() {
      console.log(this.oldpassword)
      console.log(this.newPassword)
      console.log(this.confirmPassword)
    },
    //fetch user data and privacy
    getUserById : function() {
      httpuserprofile
        .get("/userprofile/userbyid/" + sessionUtils.getUserId())
        .then(response => {
          console.log(response)
          //set visibility
          this.ProfileVisibility = response.data.privacy
          this.ProfilePictureVisibility = response.data.profilePictureVisibility
          this.profileVideoId = response.data.profileVideoId
          if(this.profileVideoId !==null){
            this.getProfileVideo();
          }
        
if(this.profileVideoId === null){   
  this.ProfileVideoVisibility ='PUBLIC'
 this.videoonlyenabled=true
   this.videofollwersenabled = true
   this.videopublicenabled=true

}
if(this.ProfileVisibility === 'PRIVATE')
{
 
  
  this.picturepublicenabled = true
  this.picturefollwersenabled = true
   this.pictureonlymeenabled=false
   if(this.profileVideoId !== null){ 
      this.ProfileVideoVisibility = 'PRIVATE' 
  this.videoonlyenabled=false
   this.videofollwersenabled = true
   this.videopublicenabled=true
   }
}
if(this.ProfileVisibility === 'FOLLOWER')
{
 
  
  this.picturepublicenabled = true
  this.picturefollwersenabled = false
   this.pictureonlymeenabled=false
   if(this.profileVideoId !== null){  
     this.ProfileVideoVisibility = 'FOLLOWER'
  this.videoonlyenabled=false
   this.videofollwersenabled = false
   this.videopublicenabled=true
   }
}
if(this.ProfileVisibility === 'PUBLIC')
{


  this.picturepublicenabled = false
  this.picturefollwersenabled = false
   this.pictureonlymeenabled=false
   if(this.profileVideoId !== null){  
       this.ProfileVideoVisibility = 'PUBLIC'
  this.videoonlyenabled=false
   this.videofollwersenabled = false
   this.videopublicenabled=false
   }
}

          this.oldtype = 'password',
          this.newtype = 'password',
          this.confirmtype = 'password'
        }).catch((e) => {
          console.log(e)
        })
    },
     getProfileVideo(){
      httpuserprofile.get("/userprofile/getVideoById?videoId="+this.profileVideoId)
      .then((response) => {
        console.log(response)
        console.log("profile video : ", response)
      
        this.ProfileVideoVisibility = response.data.visibility; 

 

      }).catch((e) => {
        console.log(e)
      })
    },
    previous(){
      this.$router.go(-1);
    },
  },
  mounted() {
    //set page scroll
    window.scrollTo(0, 0)
    this.profileId = sessionUtils.getUserProfileId()
    this.userId = sessionUtils.getUserId();
    this.getUserById()
    this.getUserDetailsDataById()
  },
  beforeDestroy() {
    
  }
};
</script>
<style scoped>

.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 4;
}
.privacyHeading,
.subhead1 {
    font-weight: bold;
}
[type="radio"]:checked+label:after {
  background-color: green; 
}
.header {
  position: fixed;
  width: 100%;
  z-index: 4;
  background: #ffffff;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
.horizontalLine {
    display: block;
    height: 1px;
    border: 0;
    padding: 0;
    border: 1px solid #E5E6EC;
    opacity: .6;
}
.contentdevider {
    /* height: 3px; */
    border: 0;
    padding: 0;
    border-bottom: 4px solid #E5E6EC;
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 6px;
  width: 80px;
}
.button-cancel1:hover{
  background-color: rgba(161, 166, 179,0.3);
}
.card-body{
  padding: 0px !important;
}
.cardpadding {
  padding: 1.25rem;
  padding-left: 1.7rem;
}
.closebtn { 
  cursor: pointer;
}
#viewpassword {
  margin-left: -23px;
}
.button-cancel2 {
    width: 80px;
    background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent; 
    border: 1px solid transparent;
    -moz-border-image: -moz-linear-gradient(top, #E6784F 0%, #EA5184 100%);
    -webkit-border-image: -webkit-linear-gradient(top, #E6784F 0%, #EA5184 100%);
    border-image: linear-gradient(to bottom, #E6784F 0%, #EA5184 100%);
    border-image-slice: 1;
}
button:focus {
    outline: none;
}
.sidemenuItem {
    cursor: pointer;
}
@media only screen and (max-width: 600px) {
  .footer {
    position: fixed;
    bottom: 0;
  }
  .topmenubar {
    margin-left: 1.5em;
  }
  .main-card {
      padding-bottom: 15% !important;
    }
}
@media screen and (min-width: 600px) {
  
}
@media screen and (max-width: 1440px ) and (min-width: 1024px) {
  
}
@media screen and (max-width: 1024px) and (min-width: 769px) {
  
}
@media screen and (max-width: 768px) and (min-width: 600px) {
  .footer {
    position: fixed;
    bottom: 0;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
    .main-card {
      padding-left: 5% !important;
      padding-right: 5% !important;
      padding-bottom: 10% !important;
    }
  }
</style>



